import { useEffect, useState } from 'react';
import '../../App.css';

const dots = [0, 1, 2, 3];
function Footer({ setPage, page, validation }) {
  const [footer_style, setStyle] = useState('back');

  useEffect(() => {
    switch (page) {
      case 1:
        setStyle('back_button_blue');
        break;
      case 2:
        setStyle('back_button_gray');
        break;
      case 3:
        setStyle('back_button_white');
        break;
      case 4:
        setStyle('back_button_blue');
        break;

      default:
        break;
    }
  }, [page]);

  const isAllowedToPass = (dot) => {
    if (validation(dot)) {
      return false;
    }
    return true;
  };

  const getDotClass = (dot) => {
    return page === dot ? 'active' : '';
  };
  return (
    <footer id="main_footer" class="marquee custom_footer">
      <div class="in">
        <div class="maxwidth">
          <div class="back">
            <button
              id="previous"
              className={footer_style}
              onClick={() => {
                setPage((currentPage) => currentPage - 1);
              }}
            >
              &uarr; Volver
            </button>
          </div>
          <div id="steps">
            <ul>
              {dots.map((dot, i) => {
                return (
                  <>
                    <li className="visible ">
                      <button
                        disabled={isAllowedToPass(dot - 1)}
                        className={getDotClass(dot)}
                        id={'dot' + i}
                        onClick={() => setPage(dot)}
                      >
                        {dot + 1}
                      </button>
                    </li>
                  </>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
